export const projectStatusChangeSiteCoreKeys = {
  header: "Projects.CreateNewProject.ProjectStatus.ChangeStatusPopup",
  statusLabel: "CreateNewProject.ProjectStatus.ChangeStatus.Status",
  dateLabel: "CreateNewProject.ProjectStatus.ChangeStatus.Date",
  statusList: "CreateNewProject.ProjectStatus.ChangeStatus.StatusList",
  allChildProgramStatusNotClosedError:
    "CreateNewProject.ProjectStatus.ChangeStatus.AllChildProgramsStatusShouldBeClosed",
  allExpenseNotBilledError:
    "CreateNewProject.ProjectStatus.ChangeStatus.ProjectExpensesShouldBeBilled",
};
export const keyProjectDetailsSiteCoreKeys = {
  keyProjectDetails: "Projects.CreateNewProject.KeyProjectDetails",
  projectCreatedMessage:
    "CreateNewProject.KeyProjectDetails.ProjectCreatedMessage",
  projectName: "CreateNewProject.KeyProjectDetails.ProjectName",
  projectKey: "CreateNewProject.KeyProjectDetails.ProjectKey",
  client: "CreateNewProject.KeyProjectDetails.Client",
  productLineDropDown: "CreateNewProject.KeyProjectDetails.ProductLineDropDown",
  primaryProductLineDropDown:
    "CreateNewProject.KeyProjectDetails.PrimaryProductLine",
  primaryProductLineChangeErrorMessage:
    "CreateNewProject.KeyProjectDetails.PrimaryProductLineChangeErrorMessage",
  projectFrameworkDropDown:
    "CreateNewProject.KeyProjectDetails.ProjectFrameworkDropDown",
  salesOffice: "CreateNewProject.KeyProjectDetails.SalesOffice",
  billingOffice: "CreateNewProject.KeyProjectDetails.BillingOffice",
  projectStatus: "CreateNewProject.KeyProjectDetails.ProjectStatus",
  projectStatusList: "CreateNewProject.KeyProjectDetails.StatusList",
  modifyKeyProjectDetailsPopupHeader:
    "CreateNewProject.KeyProjectDetails.ModifyKeyProjectDetailsPopupHeader",
  projectTab: "CreateNewProject.KeyProjectDetails.ProjectTab",
  childProgramsTab: "CreateNewProject.KeyProjectDetails.ChildProgramsTab",
  projectFeeTab: "CreateNewProject.KeyProjectDetails.ProjectFeeTab",
  feeAndExpenseTab: "CreateNewProject.KeyProjectDetails.FeeAndExpenseTab",
  frameworkDropDown:
    "CreateNewProject.KeyProjectDetails.ProjectFrameworkDropDown",
  primaryDeliveryCountry:
    "CreateNewProject.KeyProjectDetails.PrimaryDeliveryCountry",
  primaryDeliveryOffice:
    "CreateNewProject.KeyProjectDetails.PrimaryDeliveryOffice",
  primaryDeliveryOfficeChangeErrorMessage:
    "CreateNewProject.KeyProjectDetails.PrimaryDeliveryOfficeChangeErrorMessage",
  poNumberDropdown: "CreateNewProject.KeyProjectDetails.PONumberDropDown",
  clientBusinessUnit: "CreateNewProject.KeyProjectDetails.ClientBusinessUnit",
  clientCostCenter: "CreateNewProject.KeyProjectDetails.ClientCostCentre",
  ANewProjectIsBeingCreated:
    "CreateNewProject.KeyProjectDetails.ANewProjectIsBeingCreated",
  projectUpdatedSuccessMessage:
    "CreateNewProject.KeyProjectDetails.ProjectUpdatedMessage",

  allTheActivitiesAndDeliverablesThatAreAssociatedToTheSelectedProjectFramework:
    "CreateNewProject.KeyProjectDetails.AllTheActivitiesAndDeliverablesThatAreAssociatedToTheSelectedProjectFramework",
  dossierNumber: "CreateNewProject.KeyProjectDetails.DossierNumber",
  actualClient: "CreateNewProject.KeyProjectDetails.ActualClient",
};
export const officeAndContactDetailsSiteCoreKeys = {
  officeAndContactDetails: "Projects.CreateNewProject.OfficeAndContactDetails",
  salesOffice: "CreateNewProject.OfficeAndContactDetails.SalesOffice",
  billingOffice: "CreateNewProject.OfficeAndContactDetails.BillingOffice",
  localClientRelationshipOwnerDropDown:
    "CreateNewProject.OfficeAndContactDetails.LocalClientRelationshipOwnerDropDown",
  billingContactDropDown:
    "CreateNewProject.OfficeAndContactDetails.BillingContactDropDown",
  hrContactDropDown:
    "CreateNewProject.OfficeAndContactDetails.HRContactDropDown",
  projectManagerDropDown:
    "CreateNewProject.OfficeAndContactDetails.ProjectManagerDropDown",
  projectCoordinatorDropDown:
    "CreateNewProject.OfficeAndContactDetails.ProjectCoordinatorDropDown",
};
export const projectStatusSiteCoreKeys = {
  projectStatus: "Projects.CreateNewProject.ProjectStatus",
  currentStatus: "CreateNewProject.ProjectStatus.CurrentStatus",
  createdModifiedDateTableColumn:
    "CreateNewProject.ProjectStatus.CreatedModifiedDateTableColumn",
  statusTableColumn: "CreateNewProject.ProjectStatus.StatusTableColumn",
  createdModifiedByTableColumn:
    "CreateNewProject.ProjectStatus.CreatedModifiedByTableColumn",
  statusList: "CreateNewProject.ProjectStatus.StatusList",
};
export const salesCreditSiteCoreKeys = {
  salesCredit: "Projects.CreateNewProject.SalesCredit",
  addClientRelationshipOwnerSubHeading:
    "CreateNewProject.SalesCredit.AddClientRelationshipOwnerSubHeading",
  clientRelationshipOwnerDropDown:
    "CreateNewProject.SalesCredit.ClientRelationshipOwnerDropDown",
  office: "CreateNewProject.SalesCredit.Office",
  percentageDropDown: "CreateNewProject.SalesCredit.PercentageDropDown",
  totalPercentage: "CreateNewProject.SalesCredit.TotalPercentage",
  clientRelationshipOwnerTableColumn:
    "CreateNewProject.SalesCredit.ClientRelationshipOwnerTableColumn",
  officeTableColumn: "CreateNewProject.SalesCredit.OfficeTableColumn",
  percentageTableColumn: "CreateNewProject.SalesCredit.PercentageTableColumn",
  actionTableColumn: "CreateNewProject.SalesCredit.ActionTableColumn",
  areYouSureDeleteClientRelationshipOwner:
    "CreateNewProject.SalesCredit.AreYouSureYouWantToDeleteThisClientRelationshipOwner",
  minimumOneClientRelationshipOwnerRequired:
    "CreateNewProject.SalesCredit.MinimumOfOneClientRelationshipOwnerMustBeAssignedToSalesCredit",
  noClientRelationshipOwnersAvailable:
    "CreateNewProject.SalesCredit.NoClientRelationshipOwnersAvailablePleaseAddThemManually",
  totalPercentageMustBe100:
    "CreateNewProject.SalesCredit.TotalPercentageOfTheSalesCreditAssignedMustBeEqualTo100",
};
export const activityTimelineSiteCoreKeys = {
  activityTimeline: "Projects.CreateNewProject.ActivityTimeline",
  activityTimelineNextContactDate:
    "CreateNewProject.ActivityTimeline.NextContactDate",
  activityTimelineFilterByCategoryDropDown:
    "CreateNewProject.ActivityTimeline.FilterByCategoryDropDown",
  activityTimelineAddActivityButton:
    "CreateNewProject.ActivityTimeline.AddActivityButton",
  activityTimelineNoActivitiesAvailable:
    "CreateNewProject.ActivityTimeline.NoActivitiesAvailableYouCanAlsoAddActivitiesManually",
  activityTimelineBy: "CreateNewProject.ActivityTimeline.By",
  activityTimelineActivityType:
    "CreateNewProject.ActivityTimeline.ActivityType",
  activityTimelineModality: "CreateNewProject.ActivityTimeline.Modality",
  activityTimelineTopic: "CreateNewProject.ActivityTimeline.Topic",
  activityTimelineDefaultDuration:
    "CreateNewProject.ActivityTimeline.DefaultDuration",
  activityTimelineActualDuration:
    "CreateNewProject.ActivityTimeline.ActualDuration",
  activityTimelineActivityDate:
    "CreateNewProject.ActivityTimeline.ActivityDate",
  activityTimelineOnBehalfOf: "CreateNewProject.ActivityTimeline.OnBehalfOf",
  activityTimelineDeletedMessage:
    "CreateNewProject.ActivityTimeline.ActivityDeletedMessage",
  activityTimelineActualDurationMinutesList:
    "CreateNewProject.ActivityTimeline.ActualDurationMinutesList",
  activityTimelineFilterByCategoryList:
    "CreateNewProject.ActivityTimeline.FilterByCategoryList",
  activityTimelineModalityList:
    "CreateNewProject.ActivityTimeline.ModalityList",
  activityTimelineShowFilterList:
    "CreateNewProject.ActivityTimeline.ShowFilterList",
  activityTimelineFromDate: "CreateNewProject.ActivityTimeline.FromDate",
  activityTimelineToDate: "CreateNewProject.ActivityTimeline.ToDate",
  deleteActivityConfirmationText:
    "CreateNewProject.ActivityTimeline.AreYouSureYouWantToDeleteThisActivity",
};
export const activityTimelineaddActivitySiteCoreKeys = {
  activityTimeline: "Projects.CreateNewProject.ActivityTimeline.AddActivity",
  activityType:
    "CreateNewProject.ActivityTimeline.AddActivity.ActivityTypeDropDown",
  modality: "CreateNewProject.ActivityTimeline.AddActivity.ModalityDropDown",
  topic: "CreateNewProject.ActivityTimeline.AddActivity.TopicDropDown",
  defaultDurationMinutes:
    "CreateNewProject.ActivityTimeline.AddActivity.DefaultDurationMinutes",
  actualDurationMinutes:
    "CreateNewProject.ActivityTimeline.AddActivity.ActualDurationMinutesDropDown",
  activityDate: "CreateNewProject.ActivityTimeline.AddActivity.ActivityDate",
  onBehalfOfCoachId:
    "CreateNewProject.ActivityTimeline.AddActivity.OnBehalfOfDropDown",
  activityAddedMessage:
    "CreateNewProject.ActivityTimeline.AddActivity.ActivityAddedMessage",
  activityUpdatedMessage:
    "CreateNewProject.ActivityTimeline.AddActivity.ActivityUpdatedMessage",
  notesLabel: "CreateNewProject.ActivityTimeline.AddActivity.Notes",
  editActivityPopupHeader:
    "CreateNewProject.ActivityTimeline.AddActivity.EditActivityPopupHeader",
  closeConfirmationText:
    "CreateNewProject.ActivityTimeline.AddActivity.AreYouSureYouWantToDiscardTheChanges",
  changesDiscardedText:
    "CreateNewProject.ActivityTimeline.AddActivity.ChangesDiscardedMessage",
  cancelConfirmationText:
    "CreateNewProject.ActivityTimeline.AddActivity.TheDetailsWereNotSaved",
  actualDurationMinutesList:
    "CreateNewProject.ActivityTimeline.AddActivity.ActualDurationMinutesList",
  modalityList: "CreateNewProject.ActivityTimeline.AddActivity.ModalityList",
  showFilterList:
    "CreateNewProject.ActivityTimeline.AddActivity.ShowFilterList",
};
export const projectFeeDetailsCoreKeys = {
  projectFeeDetails: "Projects.CreateNewProject.ProjectFeeDetails",
  viewProjectFeeHeader:
    "CreateNewProject.ProjectFeeDetails.ViewProjectFeeHeader",
  billingTypeDropDown: "CreateNewProject.ProjectFeeDetails.BillingTypeDropDown",
  billingTriggerDropDown:
    "CreateNewProject.ProjectFeeDetails.BillingTriggerDropDown",
  currencyDropDown: "ProgramFee.FeeDetails.CurrencyDropDown",
  projectFee: "CreateNewProject.ProjectFeeDetails.ProjectFee",
  minimumTransferFee: "CreateNewProject.ProjectFeeDetails.MinimumTransferFee",
  earlyPayDays: "CreateNewProject.ProjectFeeDetails.EarlyPayDays",
  earlyPayPercentage: "CreateNewProject.ProjectFeeDetails.EarlyPayPercentage",
  earlyPayPercentageErrorMessage:
    "CreateNewProject.ProjectFeeDetails.EarlyPayPercentageErrorMessage",
  earlyPayPercentageToolTipMessage:
    "CreateNewProject.ProjectFeeDetails.EarlyPayPercentageToolTipMessage",
  proBonoCategoryDropDown:
    "CreateNewProject.ProjectFeeDetails.ProBonoCategoryDropDown",
  areYouSureYouWantToChangeTheBillingType:
    "CreateNewProject.ProjectFeeDetails.AreYouSureYouWantToChangeTheBillingType",
  areYouSureYouWantToChangeTheProjectFee:
    "CreateNewProject.ProjectFeeDetails.AreYouSureYouWantToChangeTheProjectFee",
  minimumTransferFeeShouldBeLessThanProjectFee:
    "CreateNewProject.ProjectFeeDetails.MinimumTransferFeeShouldBeLessThanProjectFee",
  projectFeeCurrencyHasToBeSameAsPOCurrency:
    "CreateNewProject.ProjectFeeDetails.ProjectFeeCurrencyHasToBeSameAsPOCurrency",
  projectFeeShouldBeGreaterThanMinimumTransferFee:
    "CreateNewProject.ProjectFeeDetails.ProjectFeeShouldBeGreaterThanMinimumTransferFee",
  projectUpdatedMessage:
    "CreateNewProject.ProjectFeeDetails.ProjectUpdatedMessage",
  billingTypeList: "CreateNewProject.ProjectFeeDetails.BillingTypeList",
  billingTriggerList: "CreateNewProject.ProjectFeeDetails.BillingTriggerList",
  proBonoCategoryList: "CreateNewProject.ProjectFeeDetails.ProBonoCategoryList",
};

export const createNewProjectHeaderSiteCoreKeys = {
  createNewProjectHeader: "Projects.CreateNewProject.CreateNewProjectHeader",
  editProjectHeader:
    "CreateNewProject.CreateNewProjectHeader.EditProjectHeader",
  viewProjectHeader:
    "CreateNewProject.CreateNewProjectHeader.ViewProjectHeader",
  viewInvoiceHistoryButton:
    "CreateNewProject.CreateNewProjectHeader.ViewInvoiceHistoryButton",
};

export const projectFeesAndExpensesSiteCoreKeys = {
  feesAndExpenses: "Projects.CreateNewProject.FeesAndExpenses",
  addFeesAndExpenses: "FeesAndExpenses.BillingItem.AddFeesExpensesButton",
  billingItemsSection: "FeesAndExpenses.BillingItemSectionHeading",
  addBillingItemBtn: "FeesAndExpenses.BillingItem.AddFeesExpensesButton",
  feeExpenseName: "FeesAndExpenses.BillingItem.FeeExpenseName",
  transactionDate: "FeesAndExpenses.BillingItem.TransactionDate",
  itemType: "FeesAndExpenses.BillingItem.Type",
  itemCategory: "FeesAndExpenses.BillingItem.Category",
  feeExpenseType: "FeesAndExpenses.BillingItem.FeeExpenseType",
  itemStatus: "FeesAndExpenses.BillingItem.Status",
  itemStatusList: "FeesAndExpenses.BillingItem.StatusList",
  unitRate: "FeesAndExpenses.BillingItem.UnitRate",
  quantity: "FeesAndExpenses.BillingItem.Quantity",
  amount: "FeesAndExpenses.BillingItem.FeeOrExpenseAmount",
  billingAmount: "FeesAndExpenses.BillingItem.BillingAmount",
  taxAmount: "FeesAndExpenses.BillingItem.TaxAmount",
  totalBillingAmount: "FeesAndExpenses.BillingItem.TotalBillingAmount",
  itemAction: "FeesAndExpenses.BillingItem.Action",
  comments: "FeesAndExpenses.BillingItem.Comments",
  noDataMessage: "FeesAndExpenses.BillingItem.FeesExpensesNotFoundMessage",
  raiseInvoiceBtn: "FeesAndExpenses.BillingItem.RaiseInvoiceButton",
  invoiceAmount: "FeesAndExpenses.BillingItem.InvoiceAmount",
  deleteFeesAndExpenseContentText:
    "FeesAndExpenses.BillingItem.AreYouSureYouwantToDeleteTheFeeOrExpense",
  totalInvoiceAmount: "FeesAndExpenses.BillingItem.TotalInvoiceAmount",
  dossierNumberActualClientNotAvailableMessage:
    "FeesAndExpenses.BillingItem.DossierNumberActualClientNotAvailableMessage",
};

export const projectAddFeesAndExpensesSiteCoreKeys = {
  addFeesAndExpenses: "Projects.CreateNewProject.AddFeesAndExpenses",
  editFeesAndExpensesHeading: "AddFeesAndExpenses.EditFeesAndExpensesHeading", // "Edit - #FEEOREXPENSENAME# [#TYPE#]",
  viewFeesAndExpensesHeading: "AddFeesAndExpenses.ViewFeesAndExpensesHeading", // "View - #FEEOREXPENSENAME# [#TYPE#]",
  selectTypeHeading: "AddFeesAndExpenses.SelectTypeHeading",
  typeHeading: "AddFeesAndExpenses.TypeHeading",
  changeTypeConfirmation: "AddFeesAndExpenses.AreYouSureYouWantToChangeTheType",
  programProjectFeeRadioButton: "AddFeesAndExpenses.AdditionalProjectFee",
  expenseRadioButton: "AddFeesAndExpenses.Expense",
  projectFeeType: "AddFeesAndExpenses.ProjectFee",
  generalTab: "AddFeesAndExpenses.GeneralTab",
  taxTab: "AddFeesAndExpenses.TaxTab",
  summaryTab: "AddFeesAndExpenses.SummaryTab",
  feeName: "AddFeesAndExpenses.GeneralTab.FeeName",
  expenseName: "AddFeesAndExpenses.GeneralTab.ExpenseName",
  transactionDate: "AddFeesAndExpenses.GeneralTab.TransactionDate",
  incurredBy: "AddFeesAndExpenses.GeneralTab.IncurredBy",
  feeDetailsHeading: "AddFeesAndExpenses.GeneralTab.FeeDetailsHeading",
  feeDetailsType: "AddFeesAndExpenses.GeneralTab.FeeDetailsHeading.FeeType",
  feeDetailsCurrency:
    "AddFeesAndExpenses.GeneralTab.FeeDetailsHeading.FeeCurrency",
  feeDetailsAmount: "AddFeesAndExpenses.GeneralTab.FeeDetailsHeading.FeeAmount",
  expenseDetailsHeading: "AddFeesAndExpenses.GeneralTab.ExpenseDetailsHeading",
  expenseDetailsCategory:
    "AddFeesAndExpenses.GeneralTab.ExpenseDetailsHeading.Category",
  expenseDetailsType:
    "AddFeesAndExpenses.GeneralTab.ExpenseDetailsHeading.ExpenseType",
  expenseDetailsUnitPrice:
    "AddFeesAndExpenses.GeneralTab.ExpenseDetailsHeading.UnitPrice",
  expenseDetailsQuantity:
    "AddFeesAndExpenses.GeneralTab.ExpenseDetailsHeading.Quantity",
  expenseDetailsCurrency:
    "AddFeesAndExpenses.GeneralTab.ExpenseDetailsHeading.ExpenseCurrency",
  expenseDetailsAmount:
    "AddFeesAndExpenses.GeneralTab.ExpenseDetailsHeading.ExpenseAmount",
  billingDetailsHeading: "AddFeesAndExpenses.GeneralTab.BillingDetailsHeading",
  billingDetailsCurrency:
    "AddFeesAndExpenses.GeneralTab.BillingDetailsHeading.BillingCurrency",
  billingDetailsExchangeRate:
    "AddFeesAndExpenses.GeneralTab.BillingDetailsHeading.ExchangeRate",
  billingDetailsTooltipMessage:
    "AddFeesAndExpenses.GeneralTab.BillingDetailsHeading.ExchangeRateTooltipMessage",
  billingDetailsConvert:
    "AddFeesAndExpenses.GeneralTab.BillingDetailsHeading.Convert",
  billingDetailsExchangeRateError:
    "AddFeesAndExpenses.GeneralTab.BillingDetailsHeading.ConvertExchangeRateToProceedErrorMessage",
  billingDetailsAmount:
    "AddFeesAndExpenses.GeneralTab.BillingDetailsHeading.BillingAmount",
  billingDetailsAmountTooltip:
    "AddFeesAndExpenses.GeneralTab.BillingDetailsHeading.BillingAmountTooltipMessage",
  summaryTabFeeName: "AddFeesAndExpenses.SummaryTab.FeeNameTableColumn",
  summaryTabFeeAmount: "AddFeesAndExpenses.SummaryTab.FeeAmountTableColumn",
  summaryTabExpenseAmount:
    "AddFeesAndExpenses.SummaryTab.ExpenseAmountTableColumn",
  summaryTabExchangeRate:
    "AddFeesAndExpenses.SummaryTab.ExchangeRateTableColumn",
  summaryTabBillingAmount:
    "AddFeesAndExpenses.SummaryTab.BillingAmountTableColumn",
  summaryTabTax: "AddFeesAndExpenses.SummaryTab.TaxTableColumn",
  summaryTabTotalInvoiceAmount:
    "AddFeesAndExpenses.SummaryTab.TotalInvoiceAmountTableColumn",
  feeTypeList: "AddFeesAndExpenses.FeeTypeList",
  cancelConfirmMessage:
    "AddFeesAndExpenses.AreYouSureYouWantToDiscardTheChanges",
  typeChangeConfirmation: "AddFeesAndExpenses.AreYouSureYouWantToChangeTheType",
  exchangeRateError:
    "AddFeesAndExpenses.GeneralTab.BillingDetailsHeading.ConvertExchangeRateToProceedErrorMessage",
  editHeading: "AddFeesAndExpenses.EditFeesAndExpensesHeading",
  summaryTabAmount: "AddFeesAndExpenses.ViewFeesAndExpenses.Summary.Amount",
  summaryTabTotalTaxAmount:
    "AddFeesAndExpenses.ViewFeesAndExpenses.Summary.TotalTaxAmount",
  summaryTabTotalBillingAmount:
    "AddFeesAndExpenses.ViewFeesAndExpenses.Summary.TotalBillingAmount",
};
export const projectRaiseInvoiceSiteCoreKeys = {
  raiseInvoiceTitle: "Projects.CreateNewProject.FeesAndExpenses.RaiseInvoice",
  downloadProformaInvoiceLinkText:
    "FeesAndExpenses.RaiseInvoice.DownloadProformaInvoiceLinkText",
  summarySectionHeader: "FeesAndExpenses.RaiseInvoice.SummarySectionHeader",
  summaryTotalAmount: "FeesAndExpenses.RaiseInvoice.Summary.TotalAmount",
  summaryTotalTaxAmount: "FeesAndExpenses.RaiseInvoice.Summary.TotalTaxAmount",
  summaryLocalInvoiceNumber:
    "FeesAndExpenses.RaiseInvoice.Summary.LocalInvoiceNumber",
  summaryTotalInvoiceAmount:
    "FeesAndExpenses.RaiseInvoice.Summary.TotalInvoiceAmount",
  feeAndExpensesSectionHeader:
    "FeesAndExpenses.RaiseInvoice.FeeAndExpensesSectionHeader",
  invoiceLineNumberTableColumn:
    "FeesAndExpenses.RaiseInvoice.FeeAndExpenses.InvoiceLineNumberTableColumn",
  feeOrExpenseNameTableColumn:
    "FeesAndExpenses.RaiseInvoice.FeeAndExpenses.FeeOrExpenseNameTableColumn",
  typeTableColumn:
    "FeesAndExpenses.RaiseInvoice.FeeAndExpenses.TypeTableColumn",
  categoryTableColumn:
    "FeesAndExpenses.RaiseInvoice.FeeAndExpenses.CategoryTableColumn",
  feeOrExpenseTypeTableColumn:
    "FeesAndExpenses.RaiseInvoice.FeeAndExpenses.FeeOrExpenseTypeTableColumn",
  billingAmountTableColumn:
    "FeesAndExpenses.RaiseInvoice.FeeAndExpenses.BillingAmountTableColumn",
  taxAmountTableColumn:
    "FeesAndExpenses.RaiseInvoice.FeeAndExpenses.TaxAmountTableColumn",
  totalInvoiceAmountTableColumn:
    "FeesAndExpenses.RaiseInvoice.FeeAndExpenses.TotalInvoiceAmountTableColumn",
  invoiceAndPODetailsSectionHeader:
    "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetailsSectionHeader",
  poNumber: "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.PONumber",
  currentPOBalance:
    "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.CurrentPOBalance",
  poShortage: "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.POShortage",
  poShortageMessage:
    "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.YouHaveAPOShortagePleaseAddANewPOTopUpExistingPO",
  invoiceButton: "FeesAndExpenses.RaiseInvoice.InvoiceButton",
  areYouSureYouWantToRaiseTheInvoice:
    "FeesAndExpenses.RaiseInvoice.AreYouSureYouWantToRaiseTheInvoice",
  successPopupHeader: "FeesAndExpenses.RaiseInvoice.SuccessPopupHeader",
  successPopupDescriptionText:
    "FeesAndExpenses.RaiseInvoice.SuccessPopupDescriptionText",
  viewInvoiceHistoryLinkText:
    "FeesAndExpenses.RaiseInvoice.SuccessPopup.ViewInvoiceHistoryLinkText",
  invoiceDate: "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.InvoiceDate",
  paymentTermsDropDown:
    "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.PaymentTermsDropDown",
  invoiceHistoryPaymentTerms: "InvoiceHistory.ViewInvoice.Summary.PaymentTerms",
  invoiceHistoryInvoiceDate: "InvoiceHistory.ViewInvoice.Summary.InvoiceDate",
  invoiceDateMustBeWithinTheAccountingPeriod:
    "FeesAndExpenses.RaiseInvoice.InvoiceDateMustBeWithinTheAccountingPeriod",
  invoiceLanguage:
    "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.InvoiceLanguage",
  invoiceLanguageList:
    "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.InvoiceLanguageList",
  localInvoiceNumber:
    "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.LocalInvoiceNumber",
  poNoAmountMessage:
    "FeesAndExpenses.RaiseInvoice.InvoiceAndPODetails.YouHaveAPOWithoutBalanceMessage",
};

export const projectInvoiceHistorySiteCoreKeys = {
  invoiceHistoryTitle: "Projects.CreateNewProject.InvoiceHistory",
  totalInvoicedAmountAsOfToday: "InvoiceHistory.TotalInvoicedAmountAsOfToday",
  invoiceNumberTableColumn: "InvoiceHistory.InvoiceNumberTableColumn",
  invoicedDateTableColumn: "InvoiceHistory.InvoiceOrReversalDateTableColumn",
  invoiceStatusTableColumn: "InvoiceHistory.InvoiceStatusTableColumn",
  totalInvoiceAmountTableColumn: "InvoiceHistory.TotalInvoiceAmountTableColumn",
  issuedByTableColumn: "InvoiceHistory.IssuedByTableColumn",
  poNumberTableColumn: "InvoiceHistory.PONumberTableColumn",
  actionTableColumn: "InvoiceHistory.ActionTableColumn",
  reverseInvoice: "InvoiceHistory.Action.Reverse",
  manageRevenueSplitAction: "InvoiceHistory.Action.ManageRevenueSplit",
  viewRevenueSplitAction: "InvoiceHistory.Action.ViewRevenueSplit",
  viewRevenueSplitMigrated: "InvoiceHistory.Action.ViewRevenueSplitMigrated",
  areYouSureYouWantToReverseTheInvoice:
    "InvoiceHistory.ConfirmationPopUp.AreYouSureYouWantToReverseTheInvoice",
  invoiceReversed: "InvoiceHistory.InvoiceReversedMessage",
  viewInvoiceHeader: "InvoiceHistory.ViewInvoicePopupHeader",
  viewReversedInvoiceHeader: "InvoiceHistory.ViewReversedInvoicePopupHeader",
  summarySectionHeader: "InvoiceHistory.ViewInvoice.SummarySectionHeader",
  summaryTotalAmount: "InvoiceHistory.ViewInvoice.Summary.TotalAmount",
  summaryTotalTaxAmount: "InvoiceHistory.ViewInvoice.Summary.TotalTaxAmount",
  summaryTotalInvoiceAmount:
    "InvoiceHistory.ViewInvoice.Summary.TotalInvoiceAmount",
  summaryUtilizedPO: "InvoiceHistory.ViewInvoice.Summary.UtilizedPO",
  summaryInvoicedStatus: "InvoiceHistory.ViewInvoice.Summary.InvoicedStatus",
  summaryPaymentTerms: "InvoiceHistory.ViewInvoice.Summary.PaymentTerms",
  summaryInvoiceDate: "InvoiceHistory.ViewInvoice.Summary.InvoiceDate",
  summaryReversedDate: "InvoiceHistory.ViewInvoice.Summary.ReversalDate",
  viewCommentLink: "InvoiceHistory.ViewInvoice.Summary.ViewCommentLink",
  feeAndExpensesSectionHeader:
    "InvoiceHistory.ViewInvoice.FeeAndExpensesSectionHeader",
  feeOrExpenseNameTableColumn:
    "InvoiceHistory.ViewInvoice.FeeAndExpenses.FeeOrExpenseNameTableColumn",
  transactionDateTableColumn:
    "InvoiceHistory.ViewInvoice.FeeAndExpenses.TransactionDateTableColumn",
  typeTableColumnView:
    "InvoiceHistory.ViewInvoice.FeeAndExpenses.TypeTableColumn",
  categoryTableColumnView:
    "InvoiceHistory.ViewInvoice.FeeAndExpenses.CategoryTableColumn",
  feeOrExpenseTypeTableColumnView:
    "InvoiceHistory.ViewInvoice.FeeAndExpenses.FeeOrExpenseTypeTableColumn",
  billingAmountTableColumnView:
    "InvoiceHistory.ViewInvoice.FeeAndExpenses.BillingAmountTableColumn",
  taxAmountTableColumnView:
    "InvoiceHistory.ViewInvoice.FeeAndExpenses.TaxAmountTableColumn",
  FeeAndExpensesTotalInvoiceAmountTableColumn:
    "InvoiceHistory.ViewInvoice.FeeAndExpenses.TotalInvoiceAmountTableColumn",
  projectFee: "InvoiceHistory.ViewInvoice.FeeAndExpenses.ProjectFee",
  invoiceStatusList: "InvoiceHistory.InvoiceStatusList",
  billingItemTypeList: "InvoiceHistory.ViewInvoice.BillingItemTypeList",
  statusInvoiced: "Status.Invoiced",
  statusReversed: "Status.Reversed",
  invoiceLineNumberTableColumn:
    "InvoiceHistory.ViewInvoice.FeeAndExpenses.InvoiceLineNumberTableColumn",
  confirmationPopUpReversalReasonDropDown:
    "InvoiceHistory.ConfirmationPopUp.ReversalReasonDropDown",
  confirmationPopUpReversalDate:
    "InvoiceHistory.ConfirmationPopUp.ReversalDate",
  confirmationPopUpCommentOther:
    "InvoiceHistory.ConfirmationPopUp.CommentOther",
  confirmationPopUpCommentBoxPlaceholderText:
    "InvoiceHistory.ConfirmationPopUp.CommentBoxPlaceholderText",
  confirmationPopUpInvoiceReversalReasonList:
    "InvoiceHistory.ConfirmationPopUp.InvoiceReversalReasonList",
  reversalReasonTableColumn: "InvoiceHistory.ReversalReasonTableColumn",
  summaryInvoiceLanguage: "InvoiceHistory.ViewInvoice.Summary.InvoiceLanguage",
  summaryReversalReason: "InvoiceHistory.ViewInvoice.Summary.ReversalReason",
  summaryReversalComment: "InvoiceHistory.ViewInvoice.Summary.ReversalComment",
  summaryLocalInvoiceNumber:
    "InvoiceHistory.ViewInvoice.Summary.LocalInvoiceNumber",
};

export const projectDownloadProformaInvoiceSiteCoreKeys = {
  downloadProformaInvoice:
    "Projects.CreateNewProject.FeesAndExpenses.RaiseInvoice.DownloadProformaInvoice",
  purchaseOrderEmail: "RaiseInvoice.DownloadProformaInvoice.PurchaseOrderEmail",
  emailTo: "RaiseInvoice.DownloadProformaInvoice.EmailTo",
  date: "RaiseInvoice.DownloadProformaInvoice.Date",
  project: "RaiseInvoice.DownloadProformaInvoice.ProjectName",
  program: "RaiseInvoice.DownloadProformaInvoice.Program",
  feeDetailsAndAmount:
    "RaiseInvoice.DownloadProformaInvoice.FeeDetailsAndAmount",
  feeOrExpenseCategoryColumn:
    "RaiseInvoice.DownloadProformaInvoice.FeeDetailsAndAmount.FeeOrExpenseCategoryColumn",
  expenseOrFeeNameColumn:
    "RaiseInvoice.DownloadProformaInvoice.FeeDetailsAndAmount.ExpenseOrFeeNameColumn",
  expenseCategoryColumn:
    "RaiseInvoice.DownloadProformaInvoice.FeeDetailsAndAmount.ExpenseCategoryColumn",
  feeOrExpenseTypeColumn:
    "RaiseInvoice.DownloadProformaInvoice.FeeDetailsAndAmount.FeeOrExpenseTypeColumn",
  taxColumn:
    "RaiseInvoice.DownloadProformaInvoice.FeeDetailsAndAmount.TaxColumn",
  finalLineItemValueColumn:
    "RaiseInvoice.DownloadProformaInvoice.FeeDetailsAndAmount.FinalLineItemValueColumn",
  totalAmountColumn:
    "RaiseInvoice.DownloadProformaInvoice.FeeDetailsAndAmount.TotalAmountColumn",
  paymentTerms: "RaiseInvoice.DownloadProformaInvoice.PaymentTerms",
  billingOfficeAddress:
    "RaiseInvoice.DownloadProformaInvoice.BillingOfficeAddress",
  PrivateAndConfidential:
    "RaiseInvoice.DownloadProformaInvoice.PrivateAndConfidential",
  Quote: "RaiseInvoice.DownloadProformaInvoice.Quote",
  PDFLogo: "RaiseInvoice.DownloadProformaInvoice.PDFLogo",
  mediumImg: "MediumImage",
};

export const childProgramsSiteCoreKeys = {
  childProgramsTitle: "Projects.CreateNewProject.ChildPrograms",
  programsSectionHeader: "CreateNewProject.ChildPrograms.ProgramsSectionHeader",
  addExistingProgramsButton:
    "CreateNewProject.ChildPrograms.AddExistingProgramsButton",
  programNameTableColumn:
    "CreateNewProject.ChildPrograms.ProgramNameTableColumn",
  programKeyTableColumn: "CreateNewProject.ChildPrograms.ProgramKeyTableColumn",
  programStatusTableColumn:
    "CreateNewProject.ChildPrograms.ProgramStatusTableColumn",
  clientNameTableColumn: "CreateNewProject.ChildPrograms.ClientNameTableColumn",
  clientManagedStatusTableColumn:
    "CreateNewProject.ChildPrograms.ClientManagedStatusTableColumn",
  participantEmailTableColumn:
    "CreateNewProject.ChildPrograms.ParticipantEmailTableColumn",
  participantMobileNumberTableColumn:
    "CreateNewProject.ChildPrograms.ParticipantMobileNumberTableColumn",
  projectManagerTableColumn:
    "CreateNewProject.ChildPrograms.ProjectManagerTableColumn",
  countryTableColumn: "CreateNewProject.ChildPrograms.CountryTableColumn",
  createdDateTableColumn:
    "CreateNewProject.ChildPrograms.CreatedDateTableColumn",
  billingContactLastNameTableColumn:
    "CreateNewProject.ChildPrograms.BillingContactLastNameTableColumn",
  hrContactLastNameTableColumn:
    "CreateNewProject.ChildPrograms.HRContactLastNameTableColumn",
  productLineTableColumn:
    "CreateNewProject.ChildPrograms.ProductLineTableColumn",
  clientRelationshipOwnerTableColumn:
    "CreateNewProject.ChildPrograms.ClientRelationshipOwnerTableColumn",
  solutionCategoryTableColumn:
    "CreateNewProject.ChildPrograms.SolutionCategoryTableColumn",
  programStartMonthYearTableColumn:
    "CreateNewProject.ChildPrograms.ProgramStartMonthYearTableColumn",
  actionTableColumn: "CreateNewProject.ChildPrograms.ActionTableColumn",
  notFinishedCreatingProjectYet:
    "CreateNewProject.ChildPrograms.YouHaventFinishedCreatingTheProjectYet",
  programStatusList: "CreateNewProject.ChildPrograms.ProgramStatusList",
  clientManagedStatusList:
    "CreateNewProject.ChildPrograms.ClientManagedStatusList",
};

export const addExistingProgramsSiteCoreKeys = {
  addExistingProgramsTitle: "Projects.CreateNewProject.AddExistingPrograms",
  searchSectionHeader:
    "CreateNewProject.AddExistingPrograms.SearchSectionHeader",
  client: "CreateNewProject.AddExistingPrograms.Client",
  projectManagerDropDown:
    "CreateNewProject.AddExistingPrograms.ProjectManagerDropDown",
  programOrParticipantName:
    "CreateNewProject.AddExistingPrograms.ProgramOrParticipantName",
  programKey: "CreateNewProject.AddExistingPrograms.ProgramKey",
  clientManagedStatusDropDown:
    "CreateNewProject.AddExistingPrograms.ClientManagedStatusDropDown",
  programStatusDropDown:
    "CreateNewProject.AddExistingPrograms.ProgramStatusDropDown",
  resultsSectionHeader:
    "CreateNewProject.AddExistingPrograms.ResultsSectionHeader",
  chooseProgramsHeader:
    "CreateNewProject.AddExistingPrograms.ChooseProgramsHeader",
  programsSelected: "CreateNewProject.AddExistingPrograms.ProgramsSelected",
  programNameTableColumn:
    "CreateNewProject.AddExistingPrograms.ProgramNameTableColumn",
  programKeyTableColumn:
    "CreateNewProject.AddExistingPrograms.ProgramKeyTableColumn",
  clientNameTableColumn:
    "CreateNewProject.AddExistingPrograms.ClientNameTableColumn",
  programStatusTableColumn:
    "CreateNewProject.AddExistingPrograms.ProgramStatusTableColumn",
  projectManagerTableColumn:
    "CreateNewProject.AddExistingPrograms.ProjectManagerTableColumn",
  clientManagedStatusTableColumn:
    "CreateNewProject.AddExistingPrograms.ClientManagedStatusTableColumn",
  participantEmailTableColumn:
    "CreateNewProject.AddExistingPrograms.ParticipantEmailTableColumn",
  participantMobileNumberTableColumn:
    "CreateNewProject.AddExistingPrograms.ParticipantMobileNumberTableColumn",
  createdDateTableColumn:
    "CreateNewProject.AddExistingPrograms.CreatedDateTableColumn",
  areYouSureYouWantToDiscardTheChanges:
    "CreateNewProject.AddExistingPrograms.AreYouSureYouWantToDiscardTheChanges",
  clientManagedStatusList:
    "CreateNewProject.ChildPrograms.ClientManagedStatusList",
  programStatusList: "CreateNewProject.AddExistingPrograms.ProgramStatusList",
  programResultStatusList:
    "CreateNewProject.AddExistingPrograms.ProgramResultStatusList",
  contains: "FilterBy.Contains",
  filterByList: "CreateNewProject.AddExistingPrograms.FilterByList",
};
